import React, { createContext, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth as checkAuthAction, setInitialized, setUser } from '../../store/authSlice';
import { selectUser, selectIsLoading, selectError, selectIsInitialized } from '../../store/authSlice';
import auth from '../../utils/auth';

// Create Auth Context
const AuthContext = createContext();

// Custom Hook for consuming AuthContext
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isLoading = useSelector(selectIsLoading);
  const error = useSelector(selectError);
  const isInitialized = useSelector(selectIsInitialized);

  // Check authentication on mount
  useEffect(() => {
    if (!isInitialized) {
      // Check if user exists in localStorage first
      const localUser = auth.getUser();
      if (localUser && !auth.isSessionExpired()) {
        // User exists and session is valid, set user in Redux and mark as initialized
        dispatch(setUser(localUser));
        dispatch(setInitialized(true));
      } else {
        // No valid local user, check with server
        dispatch(checkAuthAction());
      }
    }
  }, [dispatch, isInitialized]);

  // Derive authentication status
  const isAuthenticated = !!user;

  // Context value
  const value = {
    user,
    isAuthenticated,
    isLoading,
    error,
    isInitialized
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
